export const SUB_ACCOUNTS = [
  { key: "dava_acilis", label: "Dava Açılış", short: "Açılış" },
  { key: "savunma", label: "Savunma", short: "Savunma" },
  { key: "yd", label: "YD (Yürütmeyi Durdurma)", short: "YD" },
  { key: "ilk_karar", label: "İlk Karar", short: "İlk Karar" },
  { key: "istinaf", label: "İstinaf", short: "İstinaf" },
  { key: "temyiz", label: "Temyiz", short: "Temyiz" },
  { key: "sonuc", label: "Sonuç", short: "Sonuç" },
  { key: "vekalet_ucreti", label: "Tahsilatlar", short: "Tahsilat" },
  { key: "raporlama", label: "Raporlama", short: "Rapor" },
];

export const MAHKEME_TURLERI = [
  { key: "hukuk", label: "Hukuk" },
  { key: "ceza", label: "Ceza" },
  { key: "idare", label: "İdare" },
  { key: "is", label: "İş" },
  { key: "icra", label: "İcra" },
  { key: "aile", label: "Aile" },
  { key: "tuketici", label: "Tüketici" },
  { key: "ticaret", label: "Ticaret" },
  { key: "vergi", label: "Vergi" },
  { key: "diger", label: "Diğer" },
];

export const mahkemeTuruLabel = (k) =>
  MAHKEME_TURLERI.find((m) => m.key === k)?.label || "Hukuk";

export const ACCEPTED_EXTS = [".udf", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".jpeg", ".jpg", ".png", ".gif", ".txt"];

export const formatTRY = (n) =>
  new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
  }).format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("tr-TR", {
      day: "2-digit", month: "2-digit", year: "numeric",
    });
  } catch { return iso; }
};

export const formatSize = (bytes) => {
  if (!bytes) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  let i = 0, b = bytes;
  while (b >= 1024 && i < u.length - 1) { b /= 1024; i++; }
  return `${b.toFixed(1)} ${u[i]}`;
};
